var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWrong = function SvgWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EB1C26",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.68 2A6 6 0 1029 11.47v7.15A2.4 2.4 0 0126.58 21H2.42A2.4 2.4 0 010 18.62V4.38A2.4 2.4 0 012.42 2h19.26zM10 7.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V7.83z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 17h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25 14a7 7 0 110-14 7 7 0 010 14zM24 3v4a1 1 0 002 0V3a1 1 0 00-2 0zm1 8.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
  })))));
};
export default SvgWrong;